import { createAsyncThunk } from '@reduxjs/toolkit';
import { AICoachGoalsApi } from 'api/AICoachGoalsApi';

import { ErrorResponse } from './ErrorResponse';

export const createGetNextStepsThunk = (api: AICoachGoalsApi) =>
  createAsyncThunk('reports/getNextSteps', async (userId: string, thunkApi) => {
    try {
      const response = await api.getNextSteps(userId);
      return response.nextSteps;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue((error as ErrorResponse).response.data);
    }
  });
